export const ICON_NAV_ITEMS = [
  {
    key: "stories",
    label: "STORIES",
    href: "/stories",
    icon: "stories",
  },
  {
    key: "photography",
    label: "PHOTOGRAPHY",
    href: "/photography",
    icon: "photography",
  },
  {
    key: "video",
    label: "VIDEO",
    href: "/videos",
    icon: "video",
  },
  {
    key: "projects",
    label: "PROJECTS",
    href: "/projects",
    icon: "projects",
  },
  {
    key: "blog",
    label: "BLOG",
    href: "/blog",
    icon: "blog",
  },
];

export const LATEST_PHOTO_PLACEHOLDERS = [
  {
    caption: "[ leopard ]",
    background:
      "linear-gradient(150deg, #18120c 0%, #3a2a14 55%, #5a4520 100%)",
    shadow: "inset 0 0 70px rgba(0,0,0,0.5)",
  },
  {
    caption: "[ rider, dusk ]",
    background:
      "linear-gradient(160deg, #20303a 0%, #5a4028 55%, #b9763a 100%)",
    shadow: "inset 0 0 70px rgba(0,0,0,0.45)",
  },
  {
    caption: "[ the train ]",
    background:
      "linear-gradient(150deg, #3a1c16 0%, #7a3b2c 55%, #9a7b3a 100%)",
    shadow: "inset 0 0 70px rgba(0,0,0,0.4)",
  },
  {
    caption: "[ alpine lake ]",
    background:
      "linear-gradient(165deg, #2a3a44 0%, #4f6470 50%, #93a39a 100%)",
    shadow: "inset 0 0 70px rgba(0,0,0,0.4)",
  },
  {
    caption: "[ coastal light ]",
    background:
      "linear-gradient(160deg, #1a2430 0%, #3a5060 55%, #7a9aaa 100%)",
    shadow: "inset 0 0 70px rgba(0,0,0,0.4)",
  },
];

export const FEATURED_VIDEOS = [
  {
    caption: "[ VIDEO · dust & throttle ]",
    background:
      "linear-gradient(160deg, #3a3526 0%, #6e5a38 52%, #a98a52 100%)",
  },
  {
    caption: "[ VIDEO · from above ]",
    background:
      "linear-gradient(160deg, #123238 0%, #1f5a60 52%, #3a8a86 100%)",
  },
];
